import React from 'react'
import PropTypes from 'prop-types'

import FacilityProfileV2 from 'model/facilities/facilityProfileV2'

import in_network_icon from 'assets/in_network_icon.svg'
import out_of_network_icon from 'assets/out_of_network_icon.svg'

import { TierWrap, TierIcon } from 'pages/Providers/ProviderItem/styled'

const OON = 'out_of_network'

const FacilityTier = ({ facility }) => {
  const { insurance_tier } = facility

  if (!insurance_tier || !insurance_tier?.name) return false
  const icon =
    insurance_tier.name === OON ? out_of_network_icon : in_network_icon

  return (
    <TierWrap>
      <TierIcon>
        <img src={icon} alt="Tier" />
      </TierIcon>{' '}
      {insurance_tier?.name}
    </TierWrap>
  )
}

FacilityTier.propTypes = {
  facility: PropTypes.instanceOf(FacilityProfileV2).isRequired
}

export default FacilityTier
